import { RadioButton } from '@altify/components';
import { ReactElement, useEffect, useState } from 'react';

type TabItem = {
  content: () => ReactElement;
  key: string;
  title?: string;
};

type TabsProps = {
  listOfElements: TabItem[];
  defaultIndex?: number;
  floatingTabs?: boolean;
};

export const CustomTabs = ({
  listOfElements,
  defaultIndex = 0,
  floatingTabs = false,
}: TabsProps) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex as number);
  useEffect(() => {
    if (activeIndex !== defaultIndex) {
      setActiveIndex(defaultIndex);
    }
  }, [defaultIndex]);

  return (
    <div className="flex flex-col">
      {floatingTabs && (
        <div className="flex flex-col w-full mt-6 gap-4 mb-2">
          <div className="flex flex-row w-full justify-start flex-none">
            {listOfElements.map((element, index) => (
              <RadioButton
                selected={index == activeIndex}
                className="px-5 py-1 mx-1"
                title={element.title ?? ''}
                size="large"
                key={index}
                onPress={() => {
                  setActiveIndex(index);
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div className="w-full flex-shrink overflow-auto">
        {listOfElements.map((element, index) => (
          <div
            key={index}
            className={`w-full ${index != activeIndex ? 'hidden' : 'visible'}`}>
            {element.content()}
          </div>
        ))}
      </div>
    </div>
  );
};
